import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { updatePaymentStatus } from "../../../services/cartService";
import { OrderCard } from "./components/OrderCard";
import { CircularLoading } from "../../../components/AtomicDesign/Atoms";

interface PaymentProps {
  payStatus: null | string;
  dataOrder: OrderData;
}

export function VerifyPay() {
  const [searchParams] = useSearchParams();
  const orderID = searchParams.get("orderID");
  const [payStatus, setPayStatus] = useState<PaymentProps>({
    payStatus: null,
    dataOrder: null,
  });

  const [loading, setLoading] = useState(false);

  const getPayInfo = async () => {
    setLoading(true);
    try {
      const response = await updatePaymentStatus({
        orderID: Number(orderID),
      });
      setPayStatus({
        payStatus: response.payStatus,
        dataOrder: response.data,
      });
    } catch {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (orderID) {
      getPayInfo();
    }
    // eslint-disable-next-line
  }, [orderID]);

  const render = () => {
    if (payStatus?.dataOrder) {
      return (
        <OrderCard
          payStatus={payStatus?.payStatus}
          order={payStatus?.dataOrder}
        />
      );
    }

    return <></>;
  };

  return loading ? <CircularLoading /> : render();
}
